import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseModelResponsePageObject } from '@chicilon/angular-hrm-service';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private httpClient: HttpClient) {}
  private baseUrl = `${environment.BASE_URL}/hrm`;

  getPageDailyReport(
    filter?: string,
    sort?: string,
    page?: number,
    size?: number,
    nextCursor?: string
  ): Observable<ResponseModelResponsePageObject> {
    const encodedFilter = encodeURIComponent(filter ?? '');
    const cursorParam = nextCursor ? `&next_cursor=${encodeURIComponent(nextCursor)}` : '';
    const url = `${this.baseUrl}/daily-reports?filter=${encodedFilter}&sort=${sort ?? ''}&page=${page ?? 0}&size=${size ?? 10}${cursorParam}`;

    return this.httpClient.get<ResponseModelResponsePageObject>(url);
  }

  exportMyReport(id: string): Observable<Blob> {
    const url = `${this.baseUrl}/export/report-pdf/${id}`;

    return this.httpClient.get<Blob>(url, {
      responseType: 'blob' as 'json'
    });
  }

  exportMyExploitReport(id: string): Observable<Blob> {
    const url = `${this.baseUrl}/export/exploit-report-pdf/${id}`;

    return this.httpClient.get<Blob>(url, {
      responseType: 'blob' as 'json'
    });
  }
}
